import { SessionRealtimeChannelsModel } from "@/models";

export interface SettingsState {
  channels: SessionRealtimeChannelsModel | null;
}

export const initSettingsState = (): SettingsState => ({
  channels: null,
});

const state: SettingsState = initSettingsState();

export default state;
